export default __webpack_public_path__ + "static/media/notes.9e89ff13.svg";